<template>
    <div id="app">
        <v-app id="inspire">
            <v-parallax dark src="https://cdn.vuetifyjs.com/images/backgrounds/vbanner.jpg" height="250">
                <v-container>
                    <v-layout>
                        <h4 class="subheading font-weight-medium">ADD BRANCH EVENT</h4>
                        <v-spacer></v-spacer>
                        <h4 class="subheading font-weight-medium">{{user.displayName}}</h4>
                    </v-layout>
                </v-container>
            </v-parallax>

            <v-layout row justify-center>
                <v-dialog :value="true" persistent hide-overlay max-width="600px">
                    <v-card>
                        <v-card-text>
                            <v-container grid-list-md>
                                <v-layout wrap>
                                    <v-flex xs12>
                                        <v-text-field class="pr-0" outline label="Event*" v-model='event' required></v-text-field>
                                    </v-flex>

                                    <v-flex xs12>
                                        <v-autocomplete outline v-model="branch"  label="Branch*" :items="activeBranches" persistent-hint hide-no-data clearable leave-absolute>
                                            <template v-slot:append-outer>
                                                <v-slide-x-reverse-transition mode="out-in">
                                                </v-slide-x-reverse-transition>
                                            </template>
                                        </v-autocomplete>
                                    </v-flex>

                                    <v-flex xs12>
                                        <v-text-field outline  readonly  @click="selectdate=true" label="Date*" required :value="computedDateFormattedMomentjs"
                                        ></v-text-field>

                                        <v-dialog ref="dialog" persistent lazy full-width width="290px" v-model="selectdate" >
                                            <v-date-picker v-model="maindate" :allowed-dates="allowedDates" :min="date" scrollable @input="selectdate = false">
                                                <v-spacer></v-spacer>
                                            </v-date-picker>
                                        </v-dialog>
                                    </v-flex>

                                    <v-flex xs12>
                                        <h3 class="subheading transparent font-weight-medium justify-center">Time
                                        </h3>
                                    </v-flex>

                                    <v-flex xs6 sm6 md4 lg6>
                                        <v-select label="From*" v-model="timeFrom" outline :items="time.from" required></v-select>
                                    </v-flex>
                                
                                    <v-flex xs6>
                                        <v-select label="To*" v-model="timeTo" :items="time.to" outline required></v-select>
                                    </v-flex>

                                    <v-flex xs12 class="pb-3">
                                        <v-select v-model="remarks" outline label="Reason/Remarks*" required :items="reasons" hide-details
                                        ></v-select>
                                    </v-flex>
                                </v-layout>

                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="blue-grey" dark @click='$router.push("/branch-event")'>CANCEL</v-btn>
                                    <v-btn color="red accent-4" dark @click="setAdminCalendar()">SAVE</v-btn>
                                </v-card-actions>
                            </v-container>
                        </v-card-text>
                    </v-card>
                </v-dialog>
            </v-layout>

            <v-dialog v-model="progressDialog" persistent width="300">
                <v-card color="blue-grey darken-3">
                    <v-card-text class="subheading white--text"> {{progressMessage}}
                        <v-layout row justify-center>
                        <v-progress-linear :indeterminate="true" :size="70" :width="5" color="white"
                        ></v-progress-linear>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-dialog>

            <v-snackbar v-model="snackbar" bottom right="" :color="snackbarColor" :timeout=3000>
                {{snackbarMessage}} 
                <v-btn dark small flat @click="snackbar = false">Close</v-btn>
            </v-snackbar>

        </v-app>
    </div>
</template>

<script>
import firebase from "firebase"
import firebaseui from "firebaseui"
import "../../node_modules/firebaseui/dist/firebaseui.css"
import { config } from "../firebaseConfig"
import router from '../router'
import { db } from '../main.js'
import { mapGetters, mapActions } from "vuex"
import store from '../stores'
import moment from 'moment'
import _ from 'lodash'
export default {
    data() {
        return {
            event: "",
            selectdate: false,
            date: moment().utcOffset('+0800').toISOString().substr(0, 10),
            maindate: moment().utcOffset('+0800').toISOString().substr(0, 10),
            timeTo: "",
            timeFrom: "",
            remarks: "",
            timeStampId: null,
            allowedDates: null,
            branch: "",
            branches: [],
            snackbarColor: "",
            snackbarMessage: "",
            progressDialog: false,
            progressMessage: "",
            snackbar: false,
            activeBranches: [],
            timeHold: [],
            reasons: [],
            customers: [],
            time: {
                "from":[],
                "to": [],
                "overAllTime": [],
            },
        }
    },

    mounted() {
        this.fetchBranches()
        this.fetchTimeSelection()
        this.fetchReasons()
        console.log(this.user.email)
    },

    methods: {
        async fetchBranches() {
            let self = this 
            self.activeBranches = []
            await db.collection("Branches"+self.$stage)
                .get().then(function(querySnapshots) {
                    querySnapshots.forEach(function(doc) {
                        self.activeBranches.push(`${doc.data().branchCode}_${doc.data().businessUnit}`)
                    })
                }).then(function(){
                    if (self.activeBranches.length === 0) {
                        self.snackbarColor = "error"
                        self.snackbarMessage = "Please setup Branch"
                        self.snackbar = true
                    } else {
                        self.activeBranches = _.sortBy(self.activeBranches, o => o.cluster)
                    }
                }).catch(function(error) {
                    console.error("Error fetching document: ", error)
                    self.snackbarMessage = "Error fetching data" 
                    self.snackbarColor = "error"
                    self.snackbar= true
                })
        },

        async fetchTimeSelection(){
            let self = this
            let count = 0
            let timesChecker = []
            await db.collection("Settings"+self.$stage).doc("Schedule")
            .collection("Items").get().then(function(querySnapshot){
                querySnapshot.forEach(function(doc){
                    timesChecker.push(doc.data().time)
                    count ++

                    if (count === querySnapshot.docs.length) {
                        timesChecker.sort(function (timeA, timeB) {
                            return new Date('1970/01/01 ' + timeA) - new Date('1970/01/01 ' + timeB)
                        })
                        self.time = {
                            "from": timesChecker,
                            "to": timesChecker,
                            "overAllTime": timesChecker
                        }
                    }
                })
            }).catch(function(error) {
                console.log(error)
            })
        },
        
        async fetchReasons(){
            let self = this
            self.reasons = []

            await db.collection("Settings"+self.$stage).doc("Rejection")
            .collection("Items").get().then(function(querySnapshot) {
                querySnapshot.forEach(function(doc){
                    self.reasons.push(doc.data().reason)
                })
            }).catch(function(error){
                console.log(error)
                self.snackbar = true
                self.snackbarMessage = "Error fetching reasons"
                self.snackbarColor = "error"
            })
        },

        setAdminCalendar(){
            let self = this
            let from = self.time.overAllTime.indexOf(self.timeFrom)
            let to = self.time.overAllTime.indexOf(self.timeTo)
            self.timeStampId = new Date().getTime().toString()
            self.timeHold = []

            if (self.timeTo != "" && self.timeFrom != "" && self.event != "" && self.remarks != "" && self.branch != "") {
                self.progressDialog=true
                self.progressMessage = "Saving..."
                self.timeHold = self.time.overAllTime.splice( from , to-from + 1)
                db.collection("Events"+self.$stage).doc(self.timeStampId)
                .set({
                    "branch": self.branch,
                    "Id": self.timeStampId,
                    "event": self.event,
                    "date": self.maindate,
                    "timeHold": self.timeHold,
                    "remarks": self.remarks,
                    "To": self.timeTo,
                    "From": self.timeFrom,
                    "status": "approved",
                    "requester": self.user.email,
                    "createdDate": moment().format('MMMM Do YYYY, h:mm:ss a'),
                    "modifiedDate" : "",
                    "approvedBy": "",
                }).then(function(doc) {
                    self.checkCustomersAppointment(self.maindate,self.timeHold,self.branch)
                })
            } else if (self.timeTo == "" || self.timeFrom == ""){
                self.snackbar = true
                self.snackbarMessage = "Please pick a Time"
                self.snackbarColor = "error"
            } else if (self.event == "" || self.remarks == ""){
                self.snackbar = true
                self.snackbarMessage = "Please input Event and Remarks"
                self.snackbarColor = "error"
            } else if (self.branch == ""){
                self.snackbar = true
                self.snackbarMessage = "Please select a branch"
                self.snackbarColor = "error"
            }
        },

        checkCustomersAppointment(date,timeHold,branch) {
            let self = this
            let allCustomers = []
            let count = 0
            let branchCode = branch.split('_')[0].trim()
            db.collection("ServiceBooking"+self.$stage)
            .where("branchCode","==",branchCode)
            .where("appointmentDate","==",date)
            .where("status","==","Waiting")
            .get().then(function(snapshot) {
                snapshot.forEach(function(res) {
                    allCustomers.push(res.data())
                })
            }).then(function() {
                if (allCustomers.length > 0) {
                    allCustomers.forEach(function(data) {
                        if (timeHold.includes(data.appointmentTime)) {
                            self.customers.push(data)
                        }
                        count ++
                        if (count === allCustomers.length) {
                            if (self.customers.length > 0) {
                                self.notifications()
                            } else {
                                self.snackbar = true
                                self.snackbarMessage = "Saved"
                                self.snackbarColor = "success"
                                self.decisionDialog = false
                                self.progressDialog = false
                                setTimeout(() => {
                                    self.goToPage("branch-event")
                                }, 500);
                            }
                        }
                    })
                } else {
                    self.snackbar = true
                    self.snackbarMessage = "Saved"
                    self.snackbarColor = "success"
                    self.decisionDialog = false
                    self.progressDialog = false
                    setTimeout(() => {
                        self.goToPage("branch-event")  
                    }, 500)
                }
            })
        },

        notifications() {
            let self = this
            let message = ""
            let source = ""
            let urlSms = self.$smsUrl
            self.$axios.defaults.headers.common['Authorization'] = self.$smsAuthorization
            self.$axios.defaults.headers.common['Content-Type'] = self.$contentType

            if (self.branch.includes("Transcycle")) {
                source = "Transcycle"
            } else if (self.branch.includes("Powercycle")) {
                source = "Powercycle" 
            }

            if (self.customers.length>0) {
                self.progressMessage = "Sending Notifications"
                self.progressDialog = true
                self.customers.forEach(function(info) {
                    let message = "Dear " + info.userDetails.firstName + ",\n\nThank you for booking a service appointment with us! We are sorry to inform you that your scheduled for service on "+ info.formatedDate + " at "+ info.branch + " with Control #: " + info.transactionId + " has been cancelled due to " + self.remarks + "." + "\n\nYou can always set another schedule or feel free to visit our branches"

                    let mailerBody = {
                        "receiver" : info.userDetails.email,
                        "subject" : "Your Appointment has been Cancelled due to Event.",
                        "message" : message
                    }

                    let smsBody = {
                        "source": source,
                        "destination": `63${info.userDetails.mobileNumber}`,
                        "text": message,
                        "subaccount": self.$subAccount
                    }

                    self.$axios.post(self.$mailerUrl, mailerBody).then(function(){
                        console.log(mailerBody)
                    }).catch(error => console.log(error))

                    self.$axios.post(urlSms, smsBody).then(response => { 
                        db.collection("ServiceBooking"+self.$stage).doc(info.transactionId)
                        .update({
                            status: "Cancelled",
                            tag: "BranchEvent"
                        }).then(function() {
                            setTimeout(() => {
                                self.decisionDialog = false
                                self.progressDialog = false
                                self.snackbar = true
                                self.snackbarColor = "success"
                                self.snackbarMessage = "Saved, Notification to Customer Sent."
                                setTimeout(() => {
                                    self.goToPage("branch-event")  
                                }, 500)
                            }, 1000)
                        }).catch(function(error) {
                            console.log("Error updating document")
                        })
                    }).catch(function(error){
                        console.log("Failed sending Notifications")
                    })
                })
            } else {
                setTimeout(() => {
                    self.progressDialog = false
                    self.snackbar = true
                    self.snackbarColor = "success"
                    self.snackbarMessage = "Saved! No Affected Customer."
                    setTimeout(() => {
                        self.goToPage("branch-event")  
                    }, 500)
                }, 1000)
            }
        },

        goToPage(page) {
            this.$router.push("/"+page)
        },
    },

    computed : {
        ...mapGetters(["user"]),
        computedDateFormattedMomentjs () {
            return this.maindate ? moment(this.maindate).format('dddd, MMMM Do YYYY') : ''
        },
    },
}
</script>

<style scoped>

</style>




